/**
 *
 * @class FontVariant
 *
 * the kinds of font variation
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export enum FontVariant {
  NORMAL     = '',
  SMALL_CAPS = 'small-caps'
}
